import {Pipe, PipeTransform} from '@angular/core';

// Define a type for constructor functions
type Constructor<T = unknown> = new (...args: any[]) => T;

// Define a type for class types (with a constructor)
type ClassType<T = unknown> = Constructor<T> & Function & {[key: string]: any};

// Define a union type for both class types and constructor functions
type AnyClassConstructor<T> = ClassType<T> | Constructor<T>;

@Pipe({
	name: 'static',
	standalone: true,
	pure: true,
})
export class GetStatic implements PipeTransform {
	transform<T>(klass: AnyClassConstructor<T>, staticProperty: string): T[keyof T] | any {
		if (!klass || !staticProperty) return null;

		if (!klass.hasOwnProperty(staticProperty)) {
			debugger;
			console.warn(`Property ${staticProperty} not found on ${klass.name}`);
			return null;
		}

		// Check if klass is a class type
		if (klass.prototype) {
			return (klass as ClassType<T>)[staticProperty];
		}
		// Otherwise, it's a constructor function
		else {
			return (klass as Constructor<T>)[staticProperty];
		}
	}
}
